import "./Printpage.css";
import apf_logo from '../../../../images/apf_small_logo.png';
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const OverallPrintPage = () => {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sno = queryParams.get('data');
  // const { sno } = useParams();
  const [purchase, setPurchase] = useState(null);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (sno) {
      fetch(`${baseURL}/purchases/${sno}`)
        .then(res => res.json())
        .then(data => {
          if (data.data) {
            setPurchase(data.data);
          } else {
            setPurchase(null);
          }
        })
        .catch(err => {
          console.error("Failed to fetch purchase:", err);
          setPurchase(null);
        });
    }
  }, [sno, baseURL]);

  const getTotalEstimation = () => {
    if (!purchase?.raw_material?.length) return 0;
    return purchase.raw_material.reduce((acc, item) => acc + parseFloat(item.total_cost || 0), 0);
  };

  return (
    <div>
      <div className='page_print'>
        {purchase && (
          <>
            <div className='bg-primary py-2 px-2 rounded'>
              <div className="col-lg-12 mb-3 d-flex align-items-center justify-content-between">
                <div>
                  <img src={apf_logo} alt="Logo" className="w-200px h-150px ms-0" />
                </div>
                <div>
                  <div className='fs-1 text-white text-center mb-4 fw-semibold'>
                    Purchase List
                  </div>
                  <div className='text-white fs-6'>
                    <i className="fa-regular fa-calendar me-3 text-white"></i>
                    {new Date(purchase.purchase_date).toLocaleDateString('en-IN')}
                  </div>
                  <div className='text-white font-w600 mt-2 fs-6'>
                    {purchase.purchase_id}
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className='border-bottom border-top mb-2'>
                <div className='text-danger text-center font-w600 mt-2 mb-2 fs-4'>
                  {purchase.vendor_businessname || 'N/A'}
                </div>
                <div className='text-black text-center font-w600 mb-3 fs-6'>
                  {purchase.vendor_address || 'N/A'}
                </div>
              </div>

              <div className="col-lg-12 mb-2">
                <table className="table align-middle table-striped fs-7 gy-1 gs-2 dataTable mb-5">
                  <thead>
                    <tr className="text-start fw-bold fs-6 gs-0 bg-primary">
                      <th className='min-w-50px text-start text-white'>S.No</th>
                      <th className='min-w-100px text-white'>Raw Material</th>
                      <th className='min-w-100px text-white'>Brand</th>
                      <th className='min-w-100px text-white'>Quantity</th>
                      <th className='min-w-100px text-end text-white'>Estimated Amount</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-600 fw-semibold fs-7">
                    {purchase.raw_material?.map((item, index) => (
                      <tr key={index}>
                        <td className='text-start'>{index + 1}</td>
                        <td className='text-start'>{item.rawmaterial_name}</td>
                        <td className='text-start'>{item.brand || '-'}</td>
                        <td className='text-start'>
                          {item.quantity} {item.unitslug_name || ''}
                        </td>
                        <td className='text-end text-black'>
                          <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                          {parseFloat(item.total_cost || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className='col-lg-12 text-end'>
                <div className="row">
                  <label className="col-8 text-black fw-bold fs-4">Total Estimation</label>
                  <label className='col-4 text-danger fw-bold fs-4'>
                    ₹ {getTotalEstimation().toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                  </label>
                </div>
              </div>

              <div className='col-lg-12 text-end'>
                <div className="row">
                  <label className="col-8 text-black fw-bold fs-4">Total no Of Items</label>
                  <label className='col-4 text-danger fw-bold fs-4'>
                    {purchase.raw_material?.length || 0}
                  </label>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4 no-print">
        <Link to={'/manage-purchase'} className="btn btn-sm btn-secondary">Cancel</Link>
        <button
          className="btn btn-sm btn-primary"
          onClick={(e) => {
            e.preventDefault();
            window.print();
          }}
        >
          Print
        </button>
      </div>
    </div>
  );
};

export default OverallPrintPage;
